import { VIDEO_UPLOAD_FILENAME_PATTERN } from '@/features/uploads/config/uploadSelection';

export function isVideoUploadFile(file: File): boolean {
  if (/\.mcap$/i.test(file.name)) return false;
  return (
    file.type.toLowerCase().startsWith('video/') || VIDEO_UPLOAD_FILENAME_PATTERN.test(file.name)
  );
}
